import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import Index from './campaigns/Index';
import Details from './campaigns/Details';

export default function Campaigns() {
  return (
    <Routes>
      <Route path="" element={<Index />} />
      <Route path=":id" element={<Details />} />
      <Route path="*" element={<Navigate to="" replace />} />
    </Routes>
  );
}
